import * as React from "react";

const newLineSeperator: string = "\\n";
const boldWordPattern: RegExp = /<b>(.*?)<\/b>/g;

export const StringToHTMLParser = (
    str: string,
    builder?: (str: string,  valueKey: string, key: React.Key) => JSX.Element,
    paragraphClassName?: string,
    startingKey: number = 0,
    keysDelta: number = 1,
    groupName: string = "",
): JSX.Element[] => {
    const result: JSX.Element[] = [];

    let prevOffset = 0;
    str.replace(/{(.*?)}/g, (match, key, offset) => {

        const prevStr = str.substring(prevOffset, offset);
        const lines = prevStr.split(newLineSeperator).map((line) => {
            const lineChildren: JSX.Element[] = [];
            let prevBOffset: number = 0;
            line.replace(boldWordPattern, (bMatch, bWord, bOffset) => {
                const prevBStr = line.substring(prevBOffset, bOffset);
                lineChildren.push((
                    <>
                        {prevBStr}
                        <b>{bWord}</b>
                    </>
                ));
                prevBOffset = bOffset + bMatch.length;
                return bMatch;
            });
            lineChildren.push((
                <>
                    {line.substring(prevBOffset, line.length)}
                </>
            ));
            return lineChildren;
        });
        result.push((
            <p key={groupName + startingKey + key} className={paragraphClassName}>
                {lines.map((line, index) => {
                    return (
                        <>
                            {line}
                            {index < lines.length - 1 ? <br/> : null}
                        </>
                    );
                })}
            </p>
        ));

        result.push(builder(str, key, key + groupName + (startingKey + keysDelta)));

        prevOffset = offset + match.length;
        startingKey += keysDelta * 2;
        return match;
    });

    const lastPrevStr = str.substring(prevOffset, str.length);
    const lastLines = lastPrevStr.split("\n");
    result.push((
        <p key={groupName + startingKey + "__last"} className={paragraphClassName}>
            {lastLines.map((line, index) => {
                return (
                    <>
                        {line}
                        {index < lastLines.length - 1 ? <br/> : null}
                    </>
                );
            })}
        </p>
    ));

    return result;
};

export const ObjectFromEntries = (entries: any[][]): any => {
    const result = {};
    for (const [key, value] of entries) {
        result[key] = value;
    }
    return result;
};
